import { apiRequest } from "./client";

/**
 * Sprint 6 (Part 86) — Today aggregation contract:
 * GET /api/today → { dateUtc, role, pendingApprovals, tasksToday,
 *   overdueCount, suggestedCalls, aiEventsToday, hoursSavedToday }.
 */
export const todayApi = {
  get: async () => {
    const data = await apiRequest("/api/today");
    return {
      dateUtc: data?.dateUtc ?? null,
      role: data?.role ?? "User",
      pendingApprovals: data?.pendingApprovals || [],
      tasksToday: data?.tasksToday || [],
      overdueCount: data?.overdueCount ?? 0,
      suggestedCalls: data?.suggestedCalls || [],
      aiEventsToday: data?.aiEventsToday ?? 0,
      hoursSavedToday: data?.hoursSavedToday ?? 0,
    };
  },
};
